/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { get } from '@ember/object';
import { service } from '@ember/service';
import JurisdictionalStatus from 'linced-app/enums/jurisdictional-status';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import config from 'linced-app/config/environment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ArrivalsRoute extends Route {
  // Services
  @service
  fetch;

  @service
  session;

  @service
  store;

  model() {
    // We're not using the parent route's model, as that doesn't automatically refresh
    // if the user navigates between subroutes.  We want to always show the latest data.
    let enrolments = this.store.query('people/enrolment', {
      jurisdictionalStatus: JurisdictionalStatus.PENDING_ENROLMENT,
      include: 'people',
    });
    let model = {
      enrolments,
      people: enrolments.then((enrolments) => {
        return enrolments.map((enrolment) => {
          return this.store.peekRecord('person', enrolment.personId);
        });
      }),
      attendanceValidations: enrolments.then((enrolments) => {
        if (enrolments.length) {
          let params = {
            schoolId: this.get('session.activeSchool'),
            arrivals: enrolments.map((enrolment) => {
              return {
                personId: enrolment.personId,
                entryDate: enrolment.entryDate,
              };
            }),
          };

          let options = {
            data: JSON.stringify(params),
          };
          let url = `${config.APP.apiHost}/attendance/v4/arrivals/nzmoe/:validate`;

          return this.fetch.post(url, options).then((response) => {
            return get(response, 'results') ?? [];
          });
        }
        return [];
      }),
      uploads: this.store.query('enrolments/enrolment', {
        isPendingUpload: true,
        jurisdiction: Jurisdiction.NZ_MOE,
      }),
    };

    return hash(model);
  }

  resetController(controller) {
    controller.reset();
  }
}
